module.exports = __webpack_public_path__ + "img/print-gif.84c4dcc9.gif";